import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as LandingActions from '../actions/landing.actions';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { LandingService } from '../../services/landing.service';

@Injectable()
export class LandingEffects {
  getOpinions = createEffect(() => {
    return this.actions$.pipe(
      ofType(LandingActions.getOpinions),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      exhaustMap((action) =>
        this.landingService.getOpinions().pipe(
          map((opinions) => LandingActions.getOpinionsSuccess({ opinions })),
          catchError((error) => of(LandingActions.getOpinionsError({ error })))
        )
      )
    );
  });
  getFAQS = createEffect(() => {
    return this.actions$.pipe(
      ofType(LandingActions.getFAQS),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      exhaustMap((action) =>
        this.landingService.getFaqs().pipe(
          map((FAQS) => LandingActions.getFAQSSuccess({ FAQS })),
          catchError((error) => of(LandingActions.getFAQSError({ error })))
        )
      )
    );
  });
  getProduct$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LandingActions.getProduct),
      exhaustMap((action) =>
        this.landingService
          .getProduct(
            action.id,
            action.zipCode ? action.zipCode : null,
            action.periodicity ? action.periodicity : null
          )
          .pipe(
            map((product) => LandingActions.getProductSuccess({ product })),
            catchError((error) => of(LandingActions.getProductError({ error })))
          )
      )
    );
  });

  validateCoupon$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LandingActions.validateCoupon),
      exhaustMap((action) =>
        this.landingService.validateCoupon(action.code).pipe(
          map((response) =>
            LandingActions.validateCouponSuccess({
              discount: response.discount,
              products: response.products,
            })
          ),
          catchError((error) =>
            of(LandingActions.validateCouponError({ error }))
          )
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private landingService: LandingService
  ) {}
}
